<!-- Toolbar: matches diagram view style -->
<p-toolbar styleClass="queue-toolbar">
  <div class="p-toolbar-group-start align-items-center flex-wrap gap-1">
    <p-button icon="pi pi-list" size="small"
              [text]="selectedFilter !== 'all'"
              pTooltip="All jobs" tooltipPosition="bottom"
              (onClick)="setFilter('all')">
    </p-button>
    <p-button icon="pi pi-sync" size="small"
              [text]="selectedFilter !== 'running'"
              pTooltip="Running" tooltipPosition="bottom"
              (onClick)="setFilter('running')">
    </p-button>
    <p-button icon="pi pi-check-circle" size="small"
              [text]="selectedFilter !== 'done'"
              pTooltip="Completed" tooltipPosition="bottom"
              (onClick)="setFilter('done')">
    </p-button>
    <p-button icon="pi pi-exclamation-circle" size="small"
              [text]="selectedFilter !== 'failed'"
              pTooltip="Failed / Cancelled" tooltipPosition="bottom"
              (onClick)="setFilter('failed')">
    </p-button>
    <span class="toolbar-separator"></span>
    <p-button icon="pi pi-external-link" size="small" [text]="true"
              pTooltip="Detailed Queue" tooltipPosition="bottom"
              (onClick)="openDetailedQueue()">
    </p-button>
  </div>
</p-toolbar>

<!-- Loading spinner on initial fetch -->
<div *ngIf="loading" class="queue-loading">
  <p-progressSpinner styleClass="queue-spinner" strokeWidth="4"></p-progressSpinner>
</div>

<!-- Job list -->
<ng-container *ngIf="!loading">
  <div class="queue-list" *ngIf="filteredProcesses.length > 0; else emptyState">
    <process-status-item
      *ngFor="let process of filteredProcesses; trackBy: trackById"
      [processStatus]="process">
    </process-status-item>
  </div>
  <ng-template #emptyState>
    <div class="queue-empty">
      <i class="pi pi-inbox"></i>
      <span>No jobs found</span>
    </div>
  </ng-template>
</ng-container>


